import React from 'react';
import { Layout } from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import { SliceAI } from '@/components/ai/SliceAI';

const SliceAIPage = () => {
  return (
    <Layout>
      <PageHeader 
        title="SliceAI." 
        subtitle="Your AI-powered deal assistant"
      />
      <div className="max-w-[1200px] mx-auto">
        <SliceAI />
      </div>
    </Layout>
  );
};

export default SliceAIPage;
